<form class="card-form" [formGroup]="form" (ngSubmit)="submit()">

  <mat-card *ngIf="!success">
    <mat-card-title i18n="title @@auth.form.forgot">
      Forgot password?
    </mat-card-title>

    <mat-card-content>
      <p class="mat-typography light"
         i18n="text @@auth.form.forgot.explanation"
      >
        You will receive an email with a recovery link. Use that link to create a new password.
      </p>

      <p>
        <mat-form-field appearance="fill">
          <mat-label i18n="label @@form.email.label">Enter your email address</mat-label>
          <input type="email" matInput formControlName="email" tcAutofocus>
          <mat-error *tcMatFormFieldError i18n="error @@common.error.email.invalid">
            Enter a valid email address
          </mat-error>
        </mat-form-field>
      </p>

      <p *ngIf="errorMessage">
        <mat-error>{{ errorMessage }}</mat-error>
      </p>
    </mat-card-content>

    <mat-card-actions>
      <a mat-button color="primary" [routerLink]="['/login']" i18n="button @@common.btn.cancel">Cancel</a>
      <button type="submit" mat-raised-button color="primary" [disabled]="form.disabled" i18n="button @@auth.form.send.recovery">SEND RECOVERY LINK</button>
    </mat-card-actions>
  </mat-card>

  <mat-card *ngIf="success">
    <mat-card-title
      i18n="text @@auth.form.forgot.recovery"
    >
      Recovery link sent!
    </mat-card-title>
    <mat-card-content>
      <p class="mat-typography"
         i18n="text @@auth.form.forgot.text"
      >
        If an active account exists in Tradecloud One with this email address, a recovery link has been sent to your mailbox.
      </p>
    </mat-card-content>
  </mat-card>

</form>
